import { render, staticRenderFns } from "./ProjectSummaryClock.vue?vue&type=template&id=36ce6ee6"
import script from "./ProjectSummaryClock.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports